import React from 'react'
import type { UseDocumentLockResult } from '@ztechapps/common.hook'
import { useConfirmDialog } from '@ztechapps/common.hook'
import { ShowIf } from '@ztechapps/webui.util'
import { BusyButtonLink } from '../BusyButton/BusyButtonLink'

type DocumentLockButtonProps = {
  documentLockResult: UseDocumentLockResult
  onRefresh: () => Promise<void>
}
export const DocumentLockButton = ({ documentLockResult, onRefresh }: DocumentLockButtonProps) => {
  const { documentLock, isLocked } = documentLockResult

  const stealLock = documentLockResult.stealLock
  const currentLockUser = documentLock?.user?.profile?.name || documentLock?.user?.profile?.email || 'unknown'
  const initialMessage = `Locked for modification by ${currentLockUser}.`
  const { confirm } = useConfirmDialog({
    title: 'Are you sure you want to unlock it?',
    text: `Forcefully unlocking it will be able you to edit this document. Please coordinate first with ${currentLockUser} before proceeding because you might override his/her changes.`,
    buttons: { confirm: { text: 'Unlock it!' } },
  })

  const title = `${initialMessage}`
  const [loading, setLoading] = React.useState(false)

  const onClick = async () => {
    const onConfirm = async () => {
      try {
        setLoading(true)
        await stealLock()
        await onRefresh()
      } finally {
        setLoading(false)
      }
    }

    await confirm(onConfirm)
  }

  return (
    <ShowIf condition={isLocked}>
      <BusyButtonLink
        icon="lock"
        busyText=""
        isBusy={loading}
        title={title}
        text={currentLockUser}
        className="p-0 m-0 border-0 lh-1 text-decoration-none text-nowrap text-danger fw-bold "
        variant="link"
        onClick={onClick}
      />
    </ShowIf>
  )
}
